//Component
import AppDispatcher from '../core/AppDispatcher.jsx';
//Constants
import AppConstants from '../constants/ApplicationConstants.js';
import FundingConstants from '../constants/FundingYourProductConstants.js';
import IncomeDistributionConstants from '../constants/IncomeDistributionConstants.js';
import PensionPaymentConstants from '../constants/PensionPaymentConstants.js';
import AccountTypeConstants from '../constants/AccountTypeConstants';
//Utilities
import { EventEmitter } from 'events';
import Validators from '../utils/Validators.js';
import Mapper from '../utils/Mapper.js';
// variables
const _ = require('lodash');
const CHANGE_EVENT = 'change',
    ActionTypes = AppConstants.ActionTypes;

let _model = {
    paymentMethod: IncomeDistributionConstants.reinvestedText,
    accountHolderName: '',
    branchNumber: '',
    accountNumber: '',
    selectedBankAccount: IncomeDistributionConstants.nominateText,
    bankAccounts: []
};

let _nominateAccount = [{
    accountHolder: IncomeDistributionConstants.nominateAnotherAccount, 
    branchNumber: '', 
    accountNumber: '', 
    value: IncomeDistributionConstants.nominateText,
    id: IncomeDistributionConstants.nominateText
}];

let _customAttributeName = {
    bankAccountDetails: 'Bank account details',
    accountHolderName: 'Name of account holder',
    branchNumber: 'Branch number (BSB)',
    accountNumber: 'Account number',
    manualBankAccountDetails: 'Bank account details'
};

let _bankAccounts = [],
    _formError = [],
    _bankAccountRip = '',
    _bankAccountFunding = '',
    _showBankAccountDetailsMsg = false,
    _validationSummary = [],
    _productId,
    _isBankAccountMissing = false,
    _resetBankAccounts = true,
    _isManualEntryBankDetailsMissing = false;

function updateIncomeDistributionModel(fieldId, value, componentId){
    if (fieldId === IncomeDistributionConstants.selectedBankAccountText) {
        _formError = [];
        _model.accountHolderName = '';
        _model.branchNumber = '';
        _model.accountNumber = '';
        _isManualEntryBankDetailsMissing = false;
    }
    _model[fieldId] = Mapper.toTrim(value);
    _isBankAccountMissing = false;
    validateFields(fieldId, value, componentId);
    togglePaymentMethod(fieldId);
    showOrHideBankAccountMsg();
}

function validateFields(fieldName, fieldValue, componentId) {   
    let rules = getValidationRules(fieldName),
        data = {};
    data[fieldName] = fieldValue;
    Validators.validateField(data, rules, _customAttributeName, _formError, fieldName, componentId);
}

function validateIncomeDistributionSummary() {

    if (_productId === AppConstants.ProductIds.INVESTMENT) {
        let rules = getRules();
        let data = _.cloneDeep(_model);
        const ids = IncomeDistributionConstants.incomeDistribution + '{x}';
        if (!Validators.requiredValidation(_model.selectedBankAccount) && _model.selectedBankAccount !== IncomeDistributionConstants.nominateText && _model.paymentMethod === IncomeDistributionConstants.bankAccountText) {
            rules['bankAccountDetails'] = 'required';
            _isBankAccountMissing = true;
        }
        else if (_model.selectedBankAccount === IncomeDistributionConstants.nominateText && _model.paymentMethod === IncomeDistributionConstants.bankAccountText) {
            rules['manualBankAccountDetails'] = '';
        }
        _formError = Validators.validateAll(data, rules, _customAttributeName, ids);
        _validationSummary = Validators.validateAll(data, rules, _customAttributeName, ids, IncomeDistributionConstants.incomeDistributionHeader);
        if (!Validators.requiredValidation(_model.selectedBankAccount) && _model.paymentMethod === IncomeDistributionConstants.bankAccountText) {
            let result = _.filter(_validationSummary, function (o) { return o.id === 'incomeDistributionbankAccountDetails' });
            if (result.length === 1) {            
                _validationSummary.push({
                    clickable: result[0].clickable,
                    id: 'idSpecifyBankAccountsList',
                    message: result[0].message
                });
                _.remove(_validationSummary, { id: 'incomeDistributionbankAccountDetails' });
            }                       
        }
        else if (_model.selectedBankAccount === IncomeDistributionConstants.nominateText && _model.paymentMethod === IncomeDistributionConstants.bankAccountText) {
            let result = _.filter(_validationSummary, function (o) { return o.id === 'incomeDistributionmanualBankAccountDetails' });
            if (result.length === 1) {            
                _validationSummary.push({
                    clickable: result[0].clickable,
                    id: 'incomeDistributionaccountHolderName',
                    message: result[0].message
                });
                _.remove(_validationSummary, { id: 'incomeDistributionmanualBankAccountDetails' });
            }            
        }       
    }  
}

function getValidationRules(fieldName) {
    let allRules = getRules(),
        rulesForField = {};

    if (!fieldName) {
        return allRules;
    }
    if (!allRules[fieldName]) {
        return null;
    }
    rulesForField[fieldName] = allRules[fieldName];

    return rulesForField;
}

function getRules() {
    let rules = {};

    if (_model.selectedBankAccount === IncomeDistributionConstants.nominateText && _model.paymentMethod === IncomeDistributionConstants.bankAccountText) {
        rules[PensionPaymentConstants.FieldNames.NAME_ACC_HOLDER] = 'nameWithNumSpaces|maxLength:30';
        rules[PensionPaymentConstants.FieldNames.BRANCH_NUMBER] = 'numeric2|exactLength:6';
        rules[PensionPaymentConstants.FieldNames.ACC_NUMBER] = 'alphaNumWithSpaces|maxLength:9';
    }

    return rules;
}

function hasError(fieldName) {
    let index = _.findIndex(_formError, function(o) { return o.id === fieldName; });
    return index !== -1;
}

function showOrHideBankAccountMsg() {
    _showBankAccountDetailsMsg = _model[PensionPaymentConstants.FieldNames.ACC_NUMBER] && !hasError(IncomeDistributionConstants.incomeDistributionaccountNumberText);
}

function togglePaymentMethod(field) {
    if (field === IncomeDistributionConstants.paymentMethodText && _model.paymentMethod === IncomeDistributionConstants.reinvestedText) {
        appInit();
        _resetBankAccounts = true;
        _isBankAccountMissing = false;
        createTableBankAccounts();
    }
    else if (field === IncomeDistributionConstants.paymentMethodText && _model.paymentMethod === IncomeDistributionConstants.bankAccountText) {        
        _model.paymentMethod === IncomeDistributionConstants.bankAccountText;
        _resetBankAccounts = false;  
    }    
}

function setBankAccountsList(fundingSummary) {
    _bankAccountFunding = '';
    var dd = _.find(fundingSummary, { paymentMethod: FundingConstants.ContributionValues.DIRECT_D });
    if ((dd && dd.accountNumber) || (dd && dd.accountHolderName) || (dd && dd.branchNumber)) {
        _bankAccountFunding = dd;
    }
    createTableBankAccounts();
}

function setBankAccountsListWithRip(ripBankDetails) {
    _bankAccountRip = '';
    if ((ripBankDetails.nameOfAccountHolder || ripBankDetails.accountHolderName)  ||
        (ripBankDetails.accountNumber || ripBankDetails.bankAccount) ||
         ripBankDetails.branchNumber) {
            _bankAccountRip = ripBankDetails;
    }
    createTableBankAccounts();
}

function createTableBankAccounts() {
    if (_resetBankAccounts) {
        _bankAccounts = [];
        _model.selectedBankAccount = IncomeDistributionConstants.nominateText;

        //push from funding your investments
        if (_bankAccountFunding) {
            appendBankAccount(_bankAccountFunding);
        }
    
        //push from RIP
        if (!_bankAccountFunding && _bankAccountRip) {
            appendBankAccount(_bankAccountRip);
        }
        //push nominate bank account
        if (_bankAccounts.length > 0) {
            _.remove(_bankAccounts, {id: IncomeDistributionConstants.nominateText});
            appendNominateOtherAccount();
            _model.selectedBankAccount = '';
            if (_bankAccountFunding) {
                _model.selectedBankAccount = _bankAccounts[0].accountNumber;
            }
        }   
    } 
    
    if (_model.paymentMethod === IncomeDistributionConstants.bankAccountText) {
        _resetBankAccounts = false;
    }
}

function appendBankAccount(obj) {
    var value = '', id = '';
    if (obj.accountNumber) {
        value = obj.accountNumber;
        id = obj.accountNumber;
    }
    else if (obj.bankAccount) {
        value = obj.bankAccount;
        id = obj.bankAccount;
    }
    else if (!obj.accountNumber && obj.accountHolderName) {
        value = obj.accountHolderName;
        id = obj.accountHolderName;
    }
    else if (!obj.bankAccount && obj.nameOfAccountHolder) {
        value = obj.nameOfAccountHolder;
        id = obj.nameOfAccountHolder;
    }
    else if (!obj.accountNumber && !obj.accountHolderName && obj.branchNumber) {
        value = obj.branchNumber;
        id = obj.branchNumber;
    }
    else if (!obj.bankAccount && !obj.nameOfAccountHolder && obj.branchNumber) {
        value = obj.branchNumber;
        id = obj.branchNumber;
    }

    _bankAccounts.push({
        accountHolder: obj.accountHolderName || obj.nameOfAccountHolder,
        branchNumber: obj.branchNumber || obj.branchNumber,
        accountNumber: obj.accountNumber || obj.bankAccount,
        value: value,
        id: id
    });
}

function appendNominateOtherAccount() {
    _nominateAccount.map(function (obj) {
        _bankAccounts.push({
            accountHolder: obj.accountHolder, 
            branchNumber: obj.branchNumber, 
            accountNumber: obj.accountNumber,
            value: obj.value,
            id: obj.id
        });
    });
}

function retrieveIncomeDistribution(applicationData) {
    appInit();
    _productId = applicationData.productId;
    if (applicationData.form.incomeDistribution) {
        _model = _.clone(applicationData.form.incomeDistribution);
    }
    // retrieve bank accounts
    if (_model) {
        // set _bankAccountFunding and append to _bankAccount
        const fundingSources = _.cloneDeep(_.get(applicationData, 'form.fundingYourProduct.fundingSources', []));
        _bankAccountFunding = _.find(fundingSources, {paymentMethod: FundingConstants.ContributionValues.DIRECT_D});

        if (_bankAccountFunding) {
            appendBankAccount(_bankAccountFunding);
        }
    
        // set _bankAccountRip and append to _bankAccount
        _bankAccountRip = _.cloneDeep(_.get(applicationData, 'form.regularInvestmentPlan', null));

        if (!_bankAccountFunding && (_bankAccountRip && _bankAccountRip.ripOption === AppConstants.YesNoValues.YES)) {
            appendBankAccount(_bankAccountRip);
        }
    }
    appendNominateOtherAccount();
}

function setProductId(productId) {
    _productId = productId;
    appInit();
}

function appInit() {
    _model = {
        paymentMethod: IncomeDistributionConstants.reinvestedText,
        accountHolderName: '',
        branchNumber: '',
        accountNumber: '',
        selectedBankAccount: IncomeDistributionConstants.nominateText
    };
    _bankAccounts = [];
    _formError = [];
    _validationSummary = [];
    _showBankAccountDetailsMsg = false;   
    _resetBankAccounts = true;
    _isManualEntryBankDetailsMissing = false;
}

class IncomeDistributionStoreClass extends EventEmitter {

    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getIncomeDistributionModel() {
        _model.bankAccounts = _.filter(_bankAccounts, function (o) { return o.id !== IncomeDistributionConstants.nominateText });
        return _model;
    }

    getBankAccountsList() {
        return _bankAccounts;
    }

    getFormError() {
        return _formError;
    }

    getBankAccountDetailsMsg() {
        return _showBankAccountDetailsMsg;
    }

    getSummaryErrorList() {
        return _validationSummary;
    }

    isBankAccountMissing() {
        return _isBankAccountMissing;
    }

    isManualEntryBankDetailsMissing() {
        return _isManualEntryBankDetailsMissing;
    }
}

const IncomeDistributionStore = new IncomeDistributionStoreClass();

IncomeDistributionStore.dispatchToken = AppDispatcher.register((action) => {
    
    switch (action.actionType) {
        case ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrieveIncomeDistribution(action.applicationData);
            break;
        case ActionTypes.UPDATE_INCOME_DISTRIBUTION_MODEL:
            updateIncomeDistributionModel(action.fieldId, action.value, action.componentId);
            break;
        case ActionTypes.IS_FUNDING_SUMMARY:
            setBankAccountsList(action.summary);
            break;
        case ActionTypes.SEND_BANK_ACCOUNT_FROM_RIP:
            setBankAccountsListWithRip(action.model);
            break;
        case ActionTypes.VALIDATE_APPLICATION:
            validateIncomeDistributionSummary();
            break;
        case ActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        case AccountTypeConstants.ActionTypes.SELECT_ACCOUNT_TYPE:
            appInit();
            break;
        default:
            return true;
    }

    IncomeDistributionStore.emitChange();
    return true;
});

export default IncomeDistributionStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/IncomeDistributionStore.js